<template>
  <div class="flex h-full w-full relative">
    <HybridView
      ref="hybrid"
      v-if="isHybrid"
      :data="data"
      :isLegacy="isLegacy"
      :selectedUnits="selectedUnits"
      @selected="
        (v) => {
          selectedUnits = v;
        }
      "
      @streetview="(v) => (streetview = v)"
    />
    <MultiView
      v-if="!isHybrid"
      :selectedUnits="selectedUnits"
      :isLegacy="isLegacy"
      @selected="
        (v) => {
          selectedUnits = v;
        }
      "
    />
    <TrackingNav @click.native="getHybrid" v-if="!streetview" />
    <!-- <div class="absolute top-0 right-0" style="z-index: 999999">
      {{ selectedUnits }}
    </div> -->
  </div>
</template>

<script setup>
import { ref, watch, onMounted, computed } from 'vue';
import {
  getData,
  // searchAssetName,
  // getChart,
  // displayDetails,
} from '@/views/experimental/hybrid-view/hybridView.js';
import { useRoute, useRouter } from 'vue-router/composables';

import HybridView from '@/views/experimental/hybrid-view/HybridView.vue';
import TrackingNav from '@/views/experimental/hybrid-view/TrackingNav.vue';
import MultiView from '../multi-view/MultiView.vue';

const streetview = ref(false);

const route = useRoute();

const isLegacy = ref(false);
// lap
const fetchObj = ref({
  lap: 0,
  time: 0,
  seconds: 60,
  timer: null,
});

const isLoadingMain = ref(false);

onMounted(() => {
  fetchObj.value.lap++;
});
watch(
  () => fetchObj.value.lap,
  async () => {
    isLoadingMain.value = true;
    data.value = await getData({
      url: 'hybridUnitDetailsv2',
      fetchObj,
    });
    // console.log(data.value);
    isLoadingMain.value = false;
  },
);

const data = ref([]);
const selectedUnits = ref(null);

const hybrid = ref();

function getHybrid() {}

const isHybrid = ref(true);

onMounted(() => {
  if (route.params.view) {
    if (route.params.view == 'multi') {
      isHybrid.value = false;
    }
  }
});
watch(
  () => route.params.view,
  () => {
    if (route.params.view) {
      if (route.params.view == 'multi') {
        setTimeout(() => {
          isHybrid.value = false;
        }, 250);
      } else {
        isHybrid.value = true;
      }
    }
  },
);
</script>

<style scoped></style>
